var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultPic1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 23.5,
    fill: "#F26283",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1416 38.817L7.29103 38.5929C10.4364 33.8743 15.7008 31.0576 21.3706 31.0576H27.892C33.5617 31.0576 38.8263 33.8743 41.9716 38.5929L42.0033 38.6405C37.8785 43.7401 31.5702 47.0008 24.5003 47.0008C17.5124 47.0008 11.2685 43.8152 7.1416 38.817ZM24.6313 7.51953C18.8291 7.51953 14.1093 12.2394 14.1093 18.0415C14.1093 23.8437 18.8291 28.5635 24.6313 28.5635C30.4334 28.5635 35.1533 23.8437 35.1533 18.0415C35.1533 12.2394 30.4334 7.51953 24.6313 7.51953Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPic1);
export default __webpack_public_path__ + "static/media/defaultPic1.21f319156d453d24c41d91e588ee8a28.svg";
export { ForwardRef as ReactComponent };